module.exports = __webpack_public_path__ + "img/horef_yes.9a367841.png";